const Footer = () => {
  return (
    <footer>
      <div className="flex flex-col items-center pb-10 text-zinc-400 pt-mono">
        <p>Built by Soojeong Yoon</p>
        <a href="mailto:applotnwjd@naver.com" className="md:hidden">
          applotnwjd@naver.com
        </a>
      </div>
    </footer>
  );
};

export default Footer;
